import { AxiosResponse } from 'axios'
import api from '~/services/api'
import { IBanksList } from './../model/types'

export const fetchBanks = async () => {
  const { data }: AxiosResponse<IBanksList> = await api.get('bank/list?limit=230')
  return data.data
}
